/** Date-only, for table cells. `—` for null or garbage rather than "Invalid Date". */
export function formatWhen(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/**
 * A bare `YYYY-MM-DD` (no time, no offset), formatted as a LOCAL calendar
 * date. `new Date("2026-10-01")` reads a date-only string as UTC midnight,
 * so `formatWhen` prints a day early in every negative-offset timezone —
 * this splits the string and builds the `Date` from local y/m/d components
 * instead, the same fix `ChangelogEventList.formatDayLong` uses. `—` for
 * null or a string that is not a real calendar date.
 */
export function formatDateOnly(value: string | null | undefined): string {
  if (!value) return "—";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return "—";
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const d = new Date(year, month - 1, day);
  if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/** Date + time, for "uploaded at" and "decided at". */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
